export class AddAssistedSelfServiceInvitation {
    public customerNumberId: number;
    public customerAccountNumberId: number;
    public assistedSelfServiceTypeId: number;
    public daysExpriesIn: number;
    public message: string;
    public email: string;
    public phoneNumber: string;
    public documentId: number;
}
